import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/api/queryKeys';
import { getCurrentUserId } from '@/features/auth/session';
import { fetchNotifications, type NotificationsResponse } from '@/features/notifications/api';
import type { NotificationTab } from '@/features/notifications/types';

interface UseNotificationsQueryOptions {
  tab?: NotificationTab;
  page?: number;
  size?: number;
  enabled?: boolean;
}

/**
 * Fetch notifications from `/notification/api/v4/notification`.
 * Uses the logged-in user id automatically.
 */
export function useNotificationsQuery({
  tab = 'you',
  page = 0,
  size = 20,
  enabled = true,
}: UseNotificationsQueryOptions = {}) {
  const userId = getCurrentUserId() ?? '';

  return useQuery<NotificationsResponse>({
    queryKey: [...queryKeys.notifications.all, tab, userId, page, size] as const,
    queryFn: () => fetchNotifications({ userId, category: tab, page, size }),
    enabled: enabled && Boolean(userId),
    staleTime: 30_000,
    retry: false,
  });
}
